<template lang="pug">
  v-app#app
    #wavv-dialer.ld-storm-dialer(:class="{ 'nav-expanded': navBarExpanded }")
    div(v-if="dialerVisible" :class="{ 'dialer-visible': dialerVisible }")
    router-view
    v-snackbar(v-model="showProfileError" color="error")
      div {{ errorMessage }}
    v-footer
      v-layout
        v-flex.text-xs-center.grey--text(v-if="user") Powered by LionDesk&trade; &copy; {{ serverYear }}
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const {
  mapState: mapUserInformationState,
  mapActions: mapUserInformationActions,
  mapGetters: mapUserInformationGetters,
} = createNamespacedHelpers('userInformation');

const { mapState: mapLdAppLayoutState, mapMutations: mapLdAppLayoutMutations } =
  createNamespacedHelpers('ldAppLayout');

const { mapState: mapPreferencesState } = createNamespacedHelpers('preferences');

const { mapState: mapContactsTableState } = createNamespacedHelpers('contactsTable');

export default {
  name: 'App',
  computed: {
    ...mapPreferencesState(['navBarExpanded']),
    ...mapUserInformationState(['user']),
    ...mapUserInformationGetters(['serverYear']),
    ...mapContactsTableState(['dialerVisible']),
    ...mapLdAppLayoutState(['userInfo', 'hasError', 'errorMessage']),
    showProfileError: {
      get() {
        return this.hasError;
      },
      set(value) {
        this.setError({ hasError: false, errorMessage: '' });
      },
    },
  },
  async created() {
  },
  beforeCreate() {
    // init preferences in store (must be syncronous)
    // Canot use normal mapActions because the store isn't initialized properly
    // yet. Need to commit the action manually
    this.$store.commit('preferences/init');
  },
  methods: {
    ...mapUserInformationActions(['getUser']),
    ...mapLdAppLayoutMutations(['setError']),
    getSFStorageDomain() {
      const domainParts = window.location.hostname.split('.');
      if (domainParts.length <= 2) {
        return window.location.hostname;
      }

      return domainParts[domainParts.length - 2] + '.' + domainParts[domainParts.length - 1];
    },
  },
  watch: {
    userInfo(value) {
      if (!value) {
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ld-storm-dialer {
  margin-left: 80px;
  position: fixed;
  top: 64px;
  z-index: 2 !important;
  padding-right: 80px;

  &.nav-expanded {
    margin-left: 300px;
  }
}

.dialer-visible {
  height: 55px;
}
</style>
